<!--<div class="container-lg my-lg-4 main">-->
<!--  <div class="py-5">-->
<!--    <div class="row justify-content-center">-->
<!--      <div [hidden]="!order" class="success-box">-->
<!--        <div class="fs-2 text-center">Thank you, {{ order.payerName }}!</div>-->
<!--        <div class="text-center">Your payment of {{ order.amount }} EUR was successful.</div>-->
<!--        <div class="text-center">{{ order.creditsAdded }} credits are addded to your account.</div>-->

<!--        <div class="text-center">We've sent a confirmation to: {{ order.payerEmail }}</div>-->
<!--        <div class=" text-center pt-4">-->
<!--          <button class="rounded-5 btn btn-primary btn-lg" routerLink="/camera">Let's make some summaries!</button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<div class="container-lg my-lg-4 main">
  <div class="py-5">
    <div class="row justify-content-center">
      <div [hidden]="!order" class="success-box">
        <div class="fs-2 text-center">
          {{ 'ORDER.THANK_YOU' | translate:{ name: order.payerName } }}
        </div>
        <div class="text-center">
          {{ 'ORDER.PAYMENT_SUCCESS' | translate:{ amount: order.amount } }}
        </div>
        <div class="text-center">
          {{ 'ORDER.CREDITS_ADDED' | translate:{ credits: order.creditsAdded } }}
        </div>
        <div class="text-center">
          {{ 'ORDER.CONFIRMATION_SENT' | translate:{ email: order.payerEmail } }}
        </div>
        <div class="text-center pt-4">
          <button class="rounded-5 btn btn-primary btn-lg" routerLink="/camera">
            {{ 'ORDER.START_SUMMARIES' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>



